module.exports = __webpack_public_path__ + "static/media/cam-03.b662f3d8.webp";